import { render, staticRenderFns } from "./PolygonInfoModal.vue?vue&type=template&id=4c478b81&scoped=true&"
import script from "./PolygonInfoModal.vue?vue&type=script&lang=js&"
export * from "./PolygonInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./PolygonInfoModal.vue?vue&type=style&index=0&id=4c478b81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c478b81",
  null
  
)

export default component.exports